import { HTTP_TYPES } from '@/lib/enums'
import api from '@/api/api'

const response = {
  client: {
    async getClientDetails(clientUuid: string): Promise<any> {
      return await api(
        HTTP_TYPES.GET,
        `${import.meta.env.VITE_DEPOT_API_ADMIN}/client/${clientUuid}/`
      )
    },
    async deleteClient(clientUuid: string): Promise<any> {
      return await api(
        HTTP_TYPES.DELETE,
        `${import.meta.env.VITE_DEPOT_API_ADMIN}/client/${clientUuid}`
      )
    },
    async postCreateClient(payload: any): Promise<any> {
      // name: string
      // webhook: string

      return await api(
        HTTP_TYPES.POST,
        `${import.meta.env.VITE_DEPOT_API_ADMIN}/client/`,
        payload
      )
    },
    async postUpdateClientWebhook(payload: any): Promise<any> {
      // webhook: string

      return await api(
        HTTP_TYPES.POST,
        `${import.meta.env.VITE_DEPOT_API_ADMIN}/client/webhook`,
        payload
      )
    },
    async getRefreshClientSecret(clientId: string): Promise<any> {
      return await api(
        HTTP_TYPES.GET,
        `${import.meta.env.VITE_DEPOT_API_ADMIN}/client/${clientId}/`
      )
    },
    async deleteClientWebhook(): Promise<any> {
      return await api(
        HTTP_TYPES.DELETE,
        `${import.meta.env.VITE_DEPOT_API_ADMIN}/client/webhook`
      )
    }
  },
  clients: {
    async postGetClients(): Promise<any> {
      return await api(
        HTTP_TYPES.POST,
        `${import.meta.env.VITE_DEPOT_API_ADMIN}/clients/`,
        {}
      )
    }
  }
}

export default response
